import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./ModalBoleto.css";
import logoImg from "../assets/logo.png"; // ajuste se necessário

const ModalBoleto = ({
  aluno,
  servico = "Matrícula",
  onFechar,
  nomeEscola = "Escola Vida Abundante",
  emailEscola = "escolavidaabundante@gmail.com",
  localizacao = "Machava Km 15 Nkomane",
  nuit = "700067254",
  operador = "Usuário Logado",
  desenvolvedor = "Chaúca Creative"
}) => {
  if (!aluno) return null;

  const gerarPDF = () => {
    const doc = new jsPDF("portrait");

    const img = new Image();
    img.src = logoImg;

    img.onload = () => {
      // Logo
      const imgWidth = 35;
      const imgHeight = (img.height * imgWidth) / img.width;
      doc.addImage(img, "PNG", 10, 8, imgWidth, imgHeight);

      // Cabeçalho - lado esquerdo
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("ACADE – Gestor Escolar", 55, 15);

      doc.setFont("helvetica", "italic");
      doc.setFontSize(12);
      doc.text("Comprovativo de Pré-Registo", 55, 23);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(nomeEscola, 55, 30);
      doc.text(`Email: ${emailEscola}`, 55, 36);
      doc.text(`Localização: ${localizacao}`, 55, 42);
      doc.text(`NUIT: ${nuit}`, 55, 48);

      // Cabeçalho - lado direito
      const now = new Date().toLocaleString("pt-AO");
      doc.text(`Data: ${now}`, 200, 15, { align: "right" });
      doc.text(`Operador: ${operador}`, 200, 21, { align: "right" });

      // Corpo do boleto (tabela com dados do aluno)
      autoTable(doc, {
        startY: 55,
        styles: { fontSize: 11 },
        head: [["Campo", "Informação"]],
        body: [
          ["Número do Recibo", aluno.numero_recibo || "—"], // <-- Número do Recibo
          ["Nome do Aluno", aluno.nome_completo],
          ["Código do Aluno", aluno.codigo_aluno || aluno.codigo || "----"],
          ["Classe", aluno.classe || "—"],
          ["Serviço", servico],
          ["Entidade", "_____"],
          [
            "Referência",
            aluno.pagamentos?.[0]?.referencia ||
              aluno.Pagamentos?.[0]?.referencia ||
              aluno.pagamento?.referencia ||
              aluno.referencia_pagamento ||
              "Não gerada ainda"
          ],
          [
            "Valor a Pagar",
            `${Number(aluno.valor_matricula).toLocaleString("pt-PT", {
              style: "currency",
              currency: "MZN",
              minimumFractionDigits: 2
            })}`
          ],
          ["Data do Registo", new Date(aluno.data_matricula).toLocaleDateString("pt-PT")],
          ["Estado", aluno.ativo ? "Ativo" : "Pendente"]
        ],
        headStyles: { fillColor: [22, 160, 133], textColor: 255, halign: "center" },
        didDrawPage: (data) => {
          const pageHeight = doc.internal.pageSize.height;
          const pageWidth = doc.internal.pageSize.width;
          const pageNumber = doc.internal.getNumberOfPages();

          // Rodapé
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.text(
            `Software: ACADE-Gestor Escolar | Processado por computador. Página ${pageNumber}`,
            14,
            pageHeight - 15
          );

          doc.setDrawColor(150);
          doc.line(14, pageHeight - 13, pageWidth - 14, pageHeight - 13);

          doc.setFont("helvetica", "italic");
          doc.text(
            `Desenvolvido por ${desenvolvedor}`,
            pageWidth - 14,
            pageHeight - 8,
            { align: "right" }
          );
        }
      });

      // Observação abaixo da tabela
      doc.setFontSize(10);
      doc.text(
        "Este boleto serve como comprovativo temporário de pré-registo.",
        14,
        doc.lastAutoTable.finalY + 10
      );
      doc.text(
        "Apresente este documento na secretaria no ato do pagamento.",
        14,
        doc.lastAutoTable.finalY + 15
      );

      // Nome do arquivo com número do recibo
      const nomeArquivo = `Comprovativo_Pré-Registo_(ACADE_EVA)_${aluno.numero_recibo || "sem_recibo"}_${aluno.nome_completo.replace(/[^a-z0-9]/gi, "_")}.pdf`;
      doc.save(nomeArquivo);
    };
  };

  return (
    <div className="modal-boleto" role="dialog" aria-modal="true">
      <div className="conteudo-boleto">
        <h2><strong>Comprovativo de Pré-Registo</strong></h2>
        <p><strong>Número do Recibo:</strong> {aluno.numero_recibo || "—"}</p>
        <p><strong>Nome:</strong> {aluno.nome_completo}</p>
        <p><strong>Código do Aluno:</strong> {aluno.codigo_aluno || aluno.codigo || "----"}</p>
        <p><strong>Classe:</strong> {aluno.classe || "—"}</p>
        <p><strong>Serviço:</strong> {servico}</p>
        <p><strong>Entidade:</strong> 600123</p>
        <p><strong>Referência:</strong> {
          aluno.pagamentos?.[0]?.referencia ||
          aluno.Pagamentos?.[0]?.referencia ||
          aluno.pagamento?.referencia ||
          aluno.referencia_pagamento || "Não gerada ainda"
        }</p>
        <p><strong>Valor:</strong> {Number(aluno.valor_matricula).toLocaleString("pt-PT", {
          style: "currency", currency: "MZN"
        })}</p>
        <p><strong>Data de Registo:</strong> {new Date(aluno.data_matricula).toLocaleDateString("pt-PT")}</p>
        <p><strong>Estado:</strong> {aluno.ativo ? "Ativo" : "Pendente"}</p>

        <div className="botoes-boleto">
          <button className="btn-pdf" onClick={gerarPDF}>📤 Exportar PDF</button>
          <button className="btn-fechar" onClick={onFechar}>❌ Fechar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalBoleto;
